"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Mustache = require("mustache");
var controller_model_1 = require("../layout-models/form-models/controller.model");
var form_control_settings_component_1 = require("./form-control-settings.component");
var form_runtime_component_loader_service_1 = require("../shared/form-runtime-component-loader.service");
var ng2_dragula_1 = require("ng2-dragula");
var FormControlCentralSettings = /** @class */ (function () {
    function FormControlCentralSettings(runCompLoadService) {
        this.runCompLoadService = runCompLoadService;
        this.onClose = new core_1.EventEmitter();
    }
    FormControlCentralSettings_1 = FormControlCentralSettings;
    FormControlCentralSettings.stateChange = function ($event, controllerModel) {
        controllerModel.state = $event;
    };
    FormControlCentralSettings.getResolvedTemplate = function (template) {
        var resultMap = {
            category: 'category',
            state: 'controller.state',
            bindings: 'controller.bindings',
            fields: 'controller.fields',
            actions: 'controller.actions',
            languages: 'languages',
            stateChange: 'stateChange($event, controller)',
            currentLanguageId: 'currentLanguageId',
        };
        Mustache.parse(template, ['%{', '}']);
        return Mustache.render(template, resultMap);
    };
    FormControlCentralSettings.prototype.initSettings = function (controllerModel, categoryName, languages, currentLanguage) {
        this.controllerModel = controllerModel;
        var map = new Map();
        map.set('category', categoryName);
        map.set('state', controllerModel.state);
        map.set('controller', controllerModel);
        map.set('stateChange', form_control_settings_component_1.FormControlSettingsComponent.stateChange);
        map.set('languages', languages);
        map.set('currentLanguageId', currentLanguage.getId());
        map.set('stateChange', form_control_settings_component_1.FormControlSettingsComponent.stateChange);
        map.set('dragulaService', this.dragulaService);
        this.runCompLoadService.initComponent(this.settingsContainer, controllerModel.meta.settings.central.selector, map, FormControlCentralSettings_1.getResolvedTemplate(controllerModel.meta.settings.central.template));
    };
    FormControlCentralSettings.prototype.close = function () {
        this.cleanup();
        this.onClose.emit();
    };
    FormControlCentralSettings.prototype.cleanup = function () {
        // this.controllerModel = undefined;
        this.settingsContainer.remove();
    };
    var FormControlCentralSettings_1;
    __decorate([
        core_1.ViewChild('centralSettingsContainer', { read: core_1.ViewContainerRef }),
        __metadata("design:type", core_1.ViewContainerRef)
    ], FormControlCentralSettings.prototype, "settingsContainer", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], FormControlCentralSettings.prototype, "onClose", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", controller_model_1.ControllerModel)
    ], FormControlCentralSettings.prototype, "controllerModel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", ng2_dragula_1.DragulaService)
    ], FormControlCentralSettings.prototype, "dragulaService", void 0);
    FormControlCentralSettings = FormControlCentralSettings_1 = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'form-central-settings',
            template: require('./form-control-central.settings.html'),
        }),
        __metadata("design:paramtypes", [form_runtime_component_loader_service_1.FormRuntimeComponentLoaderService])
    ], FormControlCentralSettings);
    return FormControlCentralSettings;
}());
exports.FormControlCentralSettings = FormControlCentralSettings;
//# sourceMappingURL=form-control-central.settings.js.map